import Moment from "react-moment";
import React, {Fragment} from "react";

export const DateTimeFrom = function(props) {
    if(props.value === null) {
        return <Fragment>N/A</Fragment>;
    }
    return <Moment from={new Date()}>{props.value}</Moment>;
};